import React, { useContext  ,useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
/// React router dom
import {  Routes, Route, Outlet  } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
import ProtectedRoute from "./components/common/ProtectedRoute";

/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Dashboard2 from "./components/Dashboard/Dashboard2";
import Dashboard3 from "./components/Dashboard/Dashboard3";
import Dashboard4 from "./components/Dashboard/Dashboard4";
import Crm from "./components/Dashboard/Crm";
import Analytics from "./components/Dashboard/Analytics";
import Products from "./components/Dashboard/Products"; 
import Sales from "./components/Dashboard/Sales"; 
import Blog from "./components/Dashboard/Blog";
import Projects from "./components/Dashboard/Projects";
import Task from "./components/Dashboard/Task";


//Apps
import User from './components/AppsMenu/AppProfile/User';
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import AppProfile2 from "./components/AppsMenu/AppProfile/AppProfile2";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAccordion from "./components/bootstrap/Accordion";
import UiAlert from "./components/bootstrap/Alert";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";
// Widget
import Widget from "./pages/Widget";
/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";
/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";
/// Pages
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

import { ThemeContext } from "../context/ThemeContext";
import { navtoggle } from "../store/actions/AuthActions";


import UserPermissionManager from "./pages/admin/UserPermissionManager";
import { fetchMyPermissionsThunk } from "../store/slices/permissionSlice";
import WaterReceiptReportPage from "./pages/reports/WaterReceiptReportPage";
import SlrmReceiptReportPage from "./pages/reports/SlrmReceiptReportPage";
import WardsPage from "./pages/master/WardsPage";
import AgentsPage from "./pages/master/AgentsPage";
import HouseMasterPage from "./pages/master/HouseMasterPage";
import HouseDetailsPage from "./pages/master/HouseDetailsPage";
import HouseProfilePage from "./pages/master/HouseProfilePage";
import FinancialYearPage from "./pages/settings/FinancialYearPage";
import WaterBillSettingsPage from "./pages/settings/WaterBillSettingsPage";
import GeneralDetailsTab from "./pages/master/tabs/GeneralDetailsTab";
import ChangePasswordPage from "./pages/settings/ChangePasswordPage";
import GeneralSettingsPage from "./pages/settings/GeneralSettingsPage";
import HouseListReportPage from "./pages/reports/HouseListReportPage";
import BalanceReportPage from "./pages/reports/BalanceReportPage";
import WaterBillReportPage from "./pages/reports/WaterBillReportPage";
import ReceiptReportPage from "./pages/reports/ReceiptReportPage";
import DisconnectionReportPage from "./pages/reports/DisconnectionReportPage";
import PendingReportPage from "./pages/reports/PendingReportPage";
import WaterDcbReportPage from "./pages/reports/WaterDcbReportPage";
import HouseSummaryReportPage from "./pages/reports/HouseSummaryReportPage";
import PanchayathMasterManager from "./pages/admin/PanchayathMasterManager";
import UserPanchayathAssign from "./pages/admin/UserPanchayathAssign";
import SelectPanchayath from "./pages/SelectPanchayath";
import { withPanGuard } from "./pages/routeGuards";
import UserMasterManager from "./pages/admin/UserMasterManager";
import GramaNiskarsaReportPage from "./pages/reports/GramaNiskarsaReportPage";
import DistrictMasterManager from "./pages/admin/DistrictMasterManager";
import TalukMasterManager from "./pages/admin/TalukMasterManager";
import PrintReceiptPage from "./pages/master/tabs/PrintReceiptPage";
import HouseMasterBulkImportPage from "./pages/master/HouseMasterBulkImportPage";
import GpIncomeExpenseReportPage from "./pages/reports/GpIncomeExpenseReportPage";
import IncomeSourceMasterPage from "./pages/master/IncomeSourceMasterPage";
import ExpenseTypeMasterPage from "./pages/master/ExpenseTypeMasterPage";
import IncomeEntryPage from "./pages/finance/IncomeEntryPage";
import ExpenseEntryPage from "./pages/finance/ExpenseEntryPage";
import IncomeReportPage from "./pages/reports/IncomeReportPage";
import ExpenseReportPage from "./pages/reports/ExpenseReportPage";
import SlrmBillReportPage from "./pages/reports/SlrmBillReportPage";
import SlrmDcbReportPage from "./pages/reports/SlrmDcbReportPage";
import WasteTypeMasterPage from "./pages/master/WasteTypeMasterPage";
import WasteCoverageReportPage from "./pages/reports/WasteCoverageReportPage";
import BackupDatabasePage from "./pages/settings/BackupDatabasePage";
import ZeroBillReportPage from "./pages/reports/ZeroBillReportPage";
import OverallSummaryReportPage from "./pages/reports/OverallSummaryReportPage";
import SalesExecutivePage from "./pages/master/SalesExecutivePage";
import PanchayathMasterFormPage from "./pages/admin/PanchayathMasterFormPage";
import PanchayathBillingPage from "./pages/admin/PanchayathBillingPage";
import AccountDashboardPage from "./pages/admin/AccountDashboardPage";
import SmsGatewayPage from "./pages/settings/SmsGatewayPage";
import PanchayathProfilePage from "./pages/admin/PanchayathProfilePage";
import HouseConnectionApprovalPage from "./pages/master/HouseConnectionApprovalPage";
import PanchayathMasterReportPage from "./pages/reports/PanchayathMasterReportPage";
import PanchayathMonthlyTrackerReportPage from "./pages/reports/PanchayathMonthlyTrackerReportPage";
import PanchayathSummaryReportPage from "./pages/reports/PanchayathSummaryReportPage";
import ReceiptApprovalsPage from "./pages/settings/ReceiptApprovalsPage";
import BillingConfigurationPage from "./pages/settings/BillingConfigurationPage";
import PanchayathBillingReceiptReportPage from "./pages/reports/PanchayathBillingReceiptReportPage";
import PanchayathAccountsReportPage from "./pages/reports/PanchayathAccountsReportPage";
const allroutes = [
  // Dashboard
    { url: "", component:  <Dashboard3 /> },
   
     { 
  url: "dashboard",
  moduleKey: "dashboard",
  component: <Dashboard3/>
},

{
  url: "/account-dashboard",
  moduleKey: "account_dashboard",
  component: <AccountDashboardPage />,
},
    { url: "dashboard-dark", component: <DashboardDark/> },
    { url: "index-3", component: <Dashboard2 /> },
    { url: "index-4", component: <Dashboard3 /> },
    { url: "index-5", component: <Dashboard4 /> },
    { url: "crm", component: <Crm /> },
    { url: "analytics", component: <Analytics /> },
    { url: "products", component: <Products /> },
    { url: "sales", component: <Sales /> },
    { url: "blog", component: <Blog /> },    
    { url: "project", component: <Projects /> },  
    { url: "task", component: <Task /> },  
    
  //Apps
   
    { url: "user", component: <User /> },   
    { url: "app-profile", component: <AppProfile /> },
    { url: "app-profile-2", component: <AppProfile2 /> },
    { url: "edit-profile", component: <EditProfile /> },
    { url: "post-details", component: <PostDetails /> },        
  // Apps  
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },

  // Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-customers", component: <Customers /> },
  // Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },    
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },
  // Bootstrap
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards />},
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },  
  // Plugin
    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },   
    { url: "uc-lightgallery", component: <Lightgallery /> },
  // Widget
    { url: "widget-basic", component: <Widget /> },
  // Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },

  // table
    { url: 'table-filtering', component: <FilteringTable /> },
    { url: 'table-sorting', component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },
    { url: "select-panchayath", component: <SelectPanchayath /> },

 {
    url: "manage_user",
    moduleKey: "manage_user",
    component: withPanGuard(<UserMasterManager />),
  },
  {
  url: "house-connection-approvals",
  moduleKey: "house_connection_approvals",
  component: withPanGuard(<HouseConnectionApprovalPage />),
},
 {
    url: "district-master",
    moduleKey: "district_master",
    component: withPanGuard(<DistrictMasterManager />),
  },
 {
    url: "taluk-master",
    moduleKey: "taluk_master",
    component: withPanGuard(<TalukMasterManager />),
  },
  {
  url: "masters/sales-executives",
  moduleKey: "sales_executives",
  component: withPanGuard(<SalesExecutivePage />),
},
   {
    url: "masters/waste-types",
    moduleKey: "waste_types",
    component: withPanGuard(<WasteTypeMasterPage />),
  },
 {
    url: "user-permissions",
    moduleKey: "user_permissions",
    component: withPanGuard(<UserPermissionManager />),
  },
  {
    url: "wards",
    moduleKey: "wards",
    component: withPanGuard(<WardsPage />),
  },
  {
    url: "agents",
    moduleKey: "agents",
    component: withPanGuard(<AgentsPage />),
  },
  {
    url: "house-master",
    moduleKey: "house_master",
    component: withPanGuard(<HouseMasterPage />),
  },
   {
    url: "house-master/bulkimport",
    moduleKey: "house_master_import",
    component: withPanGuard(<HouseMasterBulkImportPage />),
  },
  {
    url: "house-profile/:home_id",
    moduleKey: "house_profile",
    component: withPanGuard(<HouseProfilePage />),
  },
  {
    url: "settings/financial-year",
    moduleKey: "financial_year",
    component: withPanGuard(<FinancialYearPage />),
  },
  {
    url: "settings/waterbill-settings",
    moduleKey: "waterbill_settings",
    component: withPanGuard(<WaterBillSettingsPage />),
  },
  {
    url: "settings/general-settings",
    moduleKey: "general_settings",
    component: withPanGuard(<GeneralSettingsPage />),
  },
  {
  url: "/settings/billing-configuration",
  moduleKey: "billing_configuration",
  component: <BillingConfigurationPage />,
},
  
  // ============================================================
// PANCHAYATH BILLING
// ============================================================

// Panchayath Full Profile
{
  url: "/settings/panchayath-master/profile/:pan_id",
  moduleKey: "panchayath_master",
  component: <PanchayathProfilePage />,
},
{
  url: "/settings/panchayath-billing",
  moduleKey: "panchayath_billing",
  component: <PanchayathBillingPage />,
},
 {
    url: "settings/change-password",
    moduleKey: "change_password",
    component: <ChangePasswordPage />,
  },
   {
    url: "settings/backup-database",
    moduleKey: "backup_database",
    component: <BackupDatabasePage />,
  },

  // 🔒 REPORTS
  {
    url: "/reports/house-list",
    moduleKey: "house_list_report",
    component: withPanGuard(<HouseListReportPage />),
  },
  {
    url: "/reports/balance",
    moduleKey: "balance_reports",
    component: withPanGuard(<BalanceReportPage />),
  },
  {
    url: "/reports/water-bill",
    moduleKey: "water_bill_reports",
    component: withPanGuard(<WaterBillReportPage />),
  },
{
  url: "/reports/slrm-bill",
  moduleKey: "slrm_bill_reports",
  component: withPanGuard(<SlrmBillReportPage />),
},

{
  url: "/reports/zero-bill",
  moduleKey: "zero_bill_reports",
  component: withPanGuard(<ZeroBillReportPage />),
},

  {
    url: "/reports/receipt",
    moduleKey: "receipt_reports",
    component: withPanGuard(<ReceiptReportPage />),
  },
  
  {
    url: "/reports/receipt-water",
    moduleKey: "water_receipt_reports",
    component: withPanGuard(<WaterReceiptReportPage />),
  },
  
  {
    url: "/reports/receipt-slrm",
    moduleKey: "slrm_receipt_reports",
    component: withPanGuard(<SlrmReceiptReportPage />),
  },
  {
    url: "/reports/disconnection",
    moduleKey: "disconnection_list",
    component: withPanGuard(<DisconnectionReportPage />),
  },
  {
    url: "/reports/pending",
    moduleKey: "pending_reports",
    component: withPanGuard(<PendingReportPage />),
  },
  {
    url: "/reports/water-dcb",
    moduleKey: "water_dcb",
    component: withPanGuard(<WaterDcbReportPage />),
  },
   {
    url: "/reports/slrm-dcb",
    moduleKey: "slrm_dcb",
    component: withPanGuard(<SlrmDcbReportPage />),
  },
  {
    url: "/reports/house-summary",
    moduleKey: "house_summary_report",
    component: withPanGuard(<HouseSummaryReportPage />),
  },
  {
    url: "/reports/gp-income-expense",
    moduleKey: "gp_income_expense_report",
    component: withPanGuard(<GpIncomeExpenseReportPage />),
  },
    {
    url: "/reports/waste-coverage",
    moduleKey: "waste_coverage_report",
    component: withPanGuard(<WasteCoverageReportPage />),
  },
  {
  url: "/reports/income-report",
  moduleKey: "income_reports",
  component: withPanGuard(<IncomeReportPage />),
},
{
  url: "/reports/expense-report",
  moduleKey: "expense_reports",
  component: withPanGuard(<ExpenseReportPage />),
},

{
  url: "/reports/overall-summary",
  moduleKey: "overall_summary_report",
  component: withPanGuard(<OverallSummaryReportPage />),
},

{
  url: "/reports/panchayath-master",
  moduleKey: "panchayath_master_report",
  component: withPanGuard(
    <PanchayathMasterReportPage />
  ),
},

{
  url: "/reports/panchayath-monthly-tracker",
  moduleKey: "panchayath_monthly_tracker",
  component: withPanGuard(
    <PanchayathMonthlyTrackerReportPage />
  ),
},

{
  url: "/reports/panchayath-summary",
  moduleKey: "panchayath_subscription_summary_report",
  component: withPanGuard(
    <PanchayathSummaryReportPage />
  ),
  
},

{
  url: "/reports/billing-receipt",
  moduleKey: "billing_receipt_report",
  component: withPanGuard(
    <PanchayathBillingReceiptReportPage />
  ),
},
{
  url: "/reports/panchayath-accounts",
  moduleKey: "panchayath_accounts_report",
  component: withPanGuard(
    <PanchayathAccountsReportPage />
  ),
},
  // 🔓 SUPERADMIN MASTER
// ============================================================
// PANCHAYATH MASTER
// ============================================================

// Panchayath List
{
  url: "/settings/panchayath-master",
  moduleKey: "panchayath_master",
  component: <PanchayathMasterManager />,
},

// Add Panchayath
{
  url: "/settings/panchayath-master/add",
  moduleKey: "panchayath_master",
  component: <PanchayathMasterFormPage />,
},

// Edit Panchayath
{
  url: "/settings/panchayath-master/edit/:pan_id",
  moduleKey: "panchayath_master",
  component: <PanchayathMasterFormPage />,
},

// Assign Panchayath
{
  url: "/settings/assign-panchayaths",
  moduleKey: "assign_panchayaths",
  component: <UserPanchayathAssign />,
},
{
  url: "/settings/sms-gateway",
  moduleKey: "sms_gateway",
  component: <SmsGatewayPage />,
},
{
  url: "/settings/receipt-approvals",
  moduleKey: "receipt_approvals",
  component: <ReceiptApprovalsPage />,
},
   {
    url: "/income-sources",
    
    component: <IncomeSourceMasterPage />,
  },
   {
    url: "/receipt/PrintReceipt/:rct_no",
    component: <PrintReceiptPage />,
  },
   {
    url: "/expense-types",
    
    component: <ExpenseTypeMasterPage />,
  },
   {
    url: "/income-entry",
    
    component: <IncomeEntryPage />,
  },
     {
    url: "/expense-entry",
    
    component: <ExpenseEntryPage />,
  },
  
];

 
  function NotFound(){    
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname
    path = path.split('/')
    path = path[path.length - 1]    
      
    if(url.indexOf(path) <= 0){     
      return <Error404 />
    }
  }



const Markup = () => {   
  
   
    return (
      <>
          <Routes>              
              <Route path='/page-lock-screen' element= {<LockScreen />} />
              <Route path='/page-error-400' element={<Error400/>} />            
              <Route path='/page-error-403' element={<Error403/>} />
              <Route path='/page-error-404' element={<Error404/>} />
              <Route path='/page-error-500' element={<Error500/>} />
              <Route path='/page-error-503' element={<Error503/>} />     
              <Route  element={<MainLayout />} > 
  {allroutes.map((data, i) => (
  <Route
    key={i}
    path={`${data.url}`}
    element={
      data.moduleKey ? (
        <ProtectedRoute moduleKey={data.moduleKey}>
          {data.component}
        </ProtectedRoute>
      ) : (
        data.component
      )
    }
  />
))}

              </Route>                
              <Route path='*' element={<NotFound/>} />     
          </Routes>     
          <ScrollToTop />
          
      </>
    );       
};


  function MainLayout(){
    const { menuToggle , sidebariconHover} = useContext(ThemeContext);

    const dispatch = useDispatch();
    const sideMenu = useSelector(state => state.sideMenu);

    
  const token = useSelector((s) => s.auth?.token) || localStorage.getItem("token");

    // const handleToogle = () => {
    //   dispatch(navtoggle());
    // };
    return (
      <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ sideMenu ? "menu-toggle" : ""}`}>  
          <Nav />
          <div
  className="content-body"
  style={{
    minHeight: window.screen.height - 45,
    backgroundColor: "#ffffffdd"
  }}
>
  <Outlet />
</div>

        <Footer />
      </div>
    )
  };



export default Markup;
